import { useEffect, useState } from "react";
import { checkHealth, type HealthState } from "../api/client";

export function HealthStatus() {
  const [health, setHealth] = useState<HealthState | null>(null);

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      checkHealth().then((h) => {
        if (!cancelled) setHealth(h);
      });
    };
    load();
    const id = setInterval(load, 30000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  if (!health) {
    return <span className="pill pill-muted">API …</span>;
  }
  if (health.warming) {
    return <span className="pill pill-warn">API warming</span>;
  }
  if (health.readyz) {
    return <span className="pill pill-ok">API ready</span>;
  }
  if (health.healthz) {
    return <span className="pill pill-warn">API up, not ready</span>;
  }
  return <span className="pill pill-bad">API down</span>;
}
